import {createStore} from "vuex";

import picklistModule from "@/store/modules/picklist";
import demandModule from "@/store/modules/demandModule";
import simulationModule from "@/store/modules/simulation";
import thirdModule from "@/store/modules/thirdModule";
import searchThirdModule from "@/store/modules/searchThirdModule";
import authModule from "@/store/modules/authModule";
import taskModule from "@/store/modules/task/taskModule";
import financingModule from "@/store/modules/financing/financingModule";

import {RootState, TaskExecuteAction} from "@/types";
import {deepClone, globalConfig, sleep} from "@/utils";
import middleOfficeModule from "@/store/modules/middle/middleOfficeModule";
import summaryPanelModule from "@/store/modules/task/actions/summaryPanelModule";
import notificationModule from "@/store/modules/communication/notification";
import messagingModule from "@/store/modules/communication/messaging";
import analysisModule from "@/store/modules/task/actions/analysisModule";
import scaleModule from "@/store/modules/configuration/ScaleModule";
import assetModule from "@/store/modules/configuration/AssetModule";
import garantyModule from "@/store/modules/configuration/GarantyModule";
import queryBuilderModule from "@/store/modules/queryBuilderModule";
import availabilityModule from "@/store/modules/configuration/availabilityModule";
import controlsModule from "@/store/modules/controls/controlsModule";
import dossierModule from "@/store/modules/dossier/DossierModule";
import commandModule from "@/store/modules/command/CommandModule";
import tabledata from "@/store/modules/tabledata";
import userModule from "@/store/modules/user/userModule";
import printDocumentModule from "@/store/modules/document/printDocumentModule";
import orderCommissionModule from "@/store/modules/order/commission/orderCommissionModule";
import orderModule from "@/store/modules/order/orderModule";
import screnConfigurationModule from "@/store/modules/configuration/ScrenConfigurationModule";
import filterModule from "./modules/filter/filterModule";
import orderPartyModule from "@/store/modules/order/party/orderPartyModule";
import roleMenuModule from "./modules/roleMenu/roleMenuModule";
import objectiveModule from "@/store/modules/objective/objectiveModule";
import AbsenceManagementModule from "./modules/AbsenceManagement/AbsenceManagementModule";
import {
  removeItem,
  removeItemMass
} from "@/commons/gathering-process-order";
import ActionModule from "@/store/modules/configuration/ActionModule";
import documentsModule from "@/store/modules/configuration/documentsModule";
import AuthorityModule from "@/store/modules/configuration/AuthorityModule";
import teamModule from "@/store/modules/configuration/teamModule";
import DaaqModule from "@/store/modules/configuration/DaaqModule";
import DelegationModule from "@/store/modules/configuration/DelegationModule";
import NetworkModule from "@/store/modules/configuration/NetworkModule";
import contextModule from "@/store/modules/configuration/contextModule";
import { createOrderDeletedDocument, removeReceivedFile } from "./services/order/orderApi";
import { executeTask } from "./services/task/workflow";
import Notify from 'quasar/src/plugins/Notify.js';;
import i18n from "@/i18n";
import { getTasks } from "./services/task/taskService";
import remunerationModule from "@/store/modules/configuration/RemunerationModule";
import { getTeamMembersByManagerCode } from "@/components/task/ts";
import aideModule from "@/store/modules/configuration/aideModule";
import signatureTemplateModule from "@/store/modules/configuration/signatureTemplateModule";
import emailConfigModule from "@/store/modules/configuration/emailConfigModule";
import { rulePayload } from "@/commons/businessRules";
import { buildAlertList, getOrderAlertList } from "./services/order/orderService";

export default createStore<RootState>({
  getters: {},
  mutations: {

    updateSelectedComponent(state, payload) {

      const path = payload.path.split('.'); // Split the path string
      let currentState: any = state;
      // Traverse through the state object following the path
      for (let i = 0; i < path.length - 1; i++) {
        currentState = currentState[path[i]];
      }

      // Update the value at the end of the path
      currentState[path[path.length - 1]] = payload.value;

    },
    setAlertList(state, payload) {
      state.alertList = payload;
    },
    /**
      * Updates the value of the `currentContext` property in the Vuex state
      * @param {RootState} state - The Vuex state
      * @param {any} payload - The new value of the `currentContext` property
      */
    setCurrentContext(state, payload) {
      state.currentContext = payload;
    },
    setToRefresh(state, payload) {
      state.toRefresh = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setLockState(state, payload) {
      state.lockState = payload;
    },
    setModule(state, payload) {
      state.module = payload;
    },
    setConfirmationDialogState(state, payload) {
      console.log(payload)
      state.confirmationDialogState = payload;
    },
    setCloseScale(state) {
      state.closeScale = !state.closeScale;
    },
    setConfirmationDeleteDialogState(state, payload) {
      state.confirmationDeleteDialogState = payload;
    },
    setCloseAvailability(state) {
      state.closeAvailability = !state.closeAvailability;
    },
    setCloseAide(state) {
      state.closeAide = !state.closeAide;
    },
  },
  actions: {
    setAlertList({ commit }) {
      commit("setAlertList", []);
      getOrderAlertList({
        orderId: "",
      })
        .then((res) => {
          const selectedOrdersAlertList = buildAlertList(res);
          const notDeletetdAlerts = selectedOrdersAlertList
            ? selectedOrdersAlertList
              .filter((alert: any) => alert && alert.alertValidity && alert.alertValidity.until === null)
              .map((item: any) => ({
                ...item,
                selected: item.selected ?? false,
              }))
            : [];
          commit("setAlertList", notDeletetdAlerts);
    
        })
        .catch((e:any) => console.error(e));
    },
    updateSelectedComponent({ commit }, payload) {
      commit('updateSelectedComponent', payload)
    },
    /**
      * Updates the value of the `currentContext` property in the Vuex state
      * @param {Object} context - The context object of the Vuex store
      * @param {any} payload - The new value of the `currentContext` property
      */
    setCurrentContext({ commit }, payload) {
      commit("setCurrentContext", payload);
    },
    startLoading({ commit }) {
      commit("setLoading", true);
    },
    stopLoading({ commit }) {
      commit("setLoading", false);
    },
    module({ commit }, payload) {
      commit("setModule", payload);
    },
    lockState({ commit }) {
      commit("setLockState", true);
    },
    toRefresh({ commit }) {
      commit("setToRefresh", true);
    },
    NoRefresh({ commit }) {
      commit("setToRefresh", false);
    },
    releaseLockState({ commit }) {
      commit("setLockState", false);
      commit("setConfirmationDialogState", {
        show: false,
        confirmation: true
      });
      commit("setCloseScale")
      commit("setCloseAvailability")
      commit("setCloseAide")
      this.dispatch("garantyModule/showGarantyDetail")
      localStorage.removeItem(globalConfig.storageKeys.thirdModule);
      localStorage.removeItem(globalConfig.storageKeys.simulationModule);
      localStorage.removeItem(globalConfig.storageKeys.orderModule);
      localStorage.removeItem(globalConfig.storageKeys.taskModule);
      localStorage.removeItem(globalConfig.storageKeys.orderTask);
      this.dispatch("demandModule/cleanState");
      this.dispatch("availabilityModule/cleanState");
      this.dispatch("dossierModule/hideDossierDetail");
      this.dispatch("dossierModule/setMode", "view");
      this.dispatch("middleOfficeModule/hideAnalysisReferenceDetails");

    },
    showConfirmationDialog({ commit }, param) {
      const { message, target, cancelButton, confirmButton, action, payload } = param;
      commit("setConfirmationDialogState", {
        message,
        cancelButton,
        confirmButton,
        target,
        show: true,
        action,
        payload
      });
    }
    ,
    hideConfirmationDialog({ commit }) {
      commit("setConfirmationDialogState", {
        show: false,
      });
    },
    hideConfirmationDeleteDialog({ commit }) {
      commit("setConfirmationDeleteDialogState", {
        show: false,
      });
    },
    executeDeleteConfirmationGaranty({ commit }, param) {
      commit("setConfirmationDialogState", {
        show: false,
        confirmation: true
      });
      this.dispatch("garantyModule/executeDeleteGaranty", { id: param.id, discriminator: param.discriminator, guarantyName: param.guarantyName });
    },
    executeDeleteConfirmationOrder({ commit }, param) {
      commit("setConfirmationDeleteDialogState", {
        show: false,
      });
      this.dispatch("orderModule/deleteOrder", {
        resourceUid: param.id,
        onSuccess: param.onSuccess
      });
    },
    async executeDeleteConfirmationOrderMass({ commit }, param) {
      commit("setConfirmationDeleteDialogState", {
        show: false,
      });
      const ids = Array.isArray(param?.ids) ? param.ids : [];
      if (!ids.length) {
        return;
      }

      await this.dispatch("orderModule/deleteOrdersMass", {
        ids,
        onSuccess: param.onSuccess
      });
    },
    async executeDeleteConfirmationObjective({ commit }, param) {
      commit("setConfirmationDeleteDialogState", {
        show: false
      });
      await this.dispatch("objectiveModule/deleteObjective", {
        payload:param,
      });
      commit("setConfirmationDeleteDialogState", {
        show: false,
        deleteAction: "DeletedObjectiveSucc"
      });
      commit("setToRefresh", true)
    },
    executeDeleteConfirmationAbsence({ commit }, param) {
      commit("setConfirmationDeleteDialogState", {
        show: false,
        deleteAction: "DeletedAbsenceSucc"
      });
      this.dispatch("AbsenceManagementModule/deleteAbsence", {
        resourceUid:param.id,
      });
      commit("setToRefresh", true)
    },
    executeDeleteConfirmationAuthority({ commit }, param) {
      commit("setConfirmationDeleteDialogState", {
        show: false,
        deleteAction: "deleteAuthoritySucc"
      });
      this.dispatch("AuthorityModule/deleteAuthority", {
        resourceUid:param.id,
      });
      commit("setToRefresh", true)
    },
    executeDeleteConfirmationSecurityGroup({ commit }, param) {
      commit("setConfirmationDeleteDialogState", {
        show: false,
        deleteAction: "deleteSecurityGroup"
      });
      this.dispatch("userModule/deleteSecurityGroup", {
        resourceUid:param.id,
      });
      commit("setToRefresh", true)
    },
    async executeDeleteConfirmationNetworknode({ commit }, param) {
      commit("setConfirmationDeleteDialogState", {
        show: false,
      });
      commit("setToRefresh", true)
      const filter = {
        networkNodeCode :param.id
      }
      getTeamMembersByManagerCode(filter)
      .then((res:any) => {
        if (res.length === 0) {
          this.dispatch("NetworkModule/deleteNetworknode", {
            resourceUid: param.id,
          });
        } else {
          Notify.create({
            message: i18n.global.t('order.messages.deleteNetworknodeImpossible'),
            color: 'negative'
        });
        }
      })
      .catch((e: any) => console.error(e));
      await sleep(2000)
      commit("setConfirmationDeleteDialogState", {
        show: false,
        deleteAction: "deleteNetworknodeSucc"
      });
      commit("setToRefresh", true)
    },

    async executeDeleteConfirmationUpdateOrderStatus({ commit, state }, param) {
      try {
        if (param.status === "ARCHIVING") {
          const taskFilter = {
            searchVariables: JSON.stringify([
              { name: "orderReference", operator: "eq", value: param.rowIndex }
            ])
          };
          const response: any = await (await getTasks(taskFilter)).data;

          if (response.length > 0) {
            const taskExecuteAction: TaskExecuteAction = {
              taskId: response[0].taskId || '',
              variables: {
                orderStatus: { value: "ARCHIVING", type: "String" },
              }
            };

            try {
              const result = await executeTask(taskExecuteAction);
              Notify.create({
                message: i18n.global.t('task.executed'),
                color: 'positive'
              });
              
            } catch (e) {
              console.error(e);
              throw e; // Re-throw to be caught by outer catch
            }
          } else {
            await this.dispatch('orderModule/updateOrderStatus', {
              orderResourceUid: param.orderid,
              status: param.status
            });
          }
        } else {
          await this.dispatch('orderModule/updateOrderStatus', {
            orderResourceUid: param.orderid,
            status: param.status
          });
        }
      } catch (e) {
        console.error(e);
        throw e;
      } finally {
        // This ensures commit is always called
        commit("setConfirmationDeleteDialogState", {
          show: false,
          confirmation: true,
          deleteAction: "UpdateOrderStatusSucc",
          Payload: param
        });
      }
    },
    executeDeleteConfirmationEvent({ commit }, param) {
      commit("setConfirmationDeleteDialogState", {
        show: false,
        confirmation: true
      });
      this.dispatch('orderModule/setPlaningEvent',
        param.events
    )
    },
    executeDeleteConfirmationQueryFilter({ dispatch }, payload) {
      dispatch("filterModule/deleteSelectedFilter", payload);
    },
    executeDeleteConfirmationRemoveAlert({ commit }, payload) {
        commit("setConfirmationDeleteDialogState", {
          show: false,
        });
        this.dispatch("orderModule/deleteOrderAlert", {
          alert:payload.alert,
          alertId:payload.id,
          orderId:payload.orderId
        });
        commit("setToRefresh", true)
    
    },
    executeDeleteConfirmationRemoveThirdOrder({ commit }, payload) {
      commit("setConfirmationDeleteDialogState", {
        show: false,
      });
      const hadFinancier = (this.state?.orderPartyModule?.orderParties || []).some((p: any) => p.role_code === 'FINANCIER');
      const hasFinancier = (payload || []).some((p: any) => p.role_code === 'FINANCIER');
      this.dispatch("orderPartyModule/setListOrderParties", { orderParties:payload });
      if (hadFinancier && !hasFinancier) {
        this.dispatch('orderModule/orderFinancingModule/resetFinancing');
      }
      this.dispatch('orderModule/changeProposalAssetItem',true)
      commit("setToRefresh", true)
  
  },
  async executeDeleteConfirmationRemoveDocumentOrder({ commit }, payload) {
    commit("setConfirmationDeleteDialogState", {
      show: false,
    });
    const clone =deepClone(payload)
    await removeReceivedFile(payload.processResourceUid,payload.receivedFilesUid)
    removeItem(payload.processResourceUid,payload.getGatheringProcessNumber,payload.getGatheringProcessIndex)
    


      this.dispatch("orderModule/createOrderDeletedDocument", {
          orderResourceUid: clone.orderResourceUid,
          fileResourceUid:clone.file?.resourceUid,
      });
    commit("setToRefresh", true)
    const { getRequiredDocumentValidatedByBR } = await import("@/store/services/task/actions/uploadDocumentService");
    await getRequiredDocumentValidatedByBR(payload.processResourceUid, clone.orderResourceUid, "orderModule").catch((e: any) => console.error(e));

},
async executeDeleteConfirmationRemoveDocumentOrderEnMasse({ commit }, payload) {
  commit("setConfirmationDeleteDialogState", {
    show: false,
    deleteAction: "DeletedDocumentsSucc"
  });
  const documents = payload.documents || [];
  for (const document of documents) {
      await removeReceivedFile(document.processResourceUid,document.receivedFilesUid)
      removeItem(document.processResourceUid,document.getGatheringProcessNumber,document.getGatheringProcessIndex);
      this.dispatch("orderModule/createOrderDeletedDocument", {
        orderResourceUid: payload?.orderResourceUid,
        fileResourceUid: document?.documentUpload?.resourceUid
    });
  }
  commit("setToRefresh", true)
  const { getRequiredDocumentValidatedByBRBatch } = await import("@/store/services/task/actions/uploadDocumentService");
  const processIds662 = Array.from(new Set(documents.map((d: any) => d.processResourceUid).filter(Boolean)));
  if (processIds662.length) {
    await getRequiredDocumentValidatedByBRBatch(processIds662 as string[], payload?.orderResourceUid, "orderModule").catch((e: any) => console.error(e));
  }

},
executeDeleteConfirmationRemoveDocumentTaskEnMasse({ commit }, payload) {
  commit("setConfirmationDeleteDialogState", {
    show: false,
    deleteAction: "DeletedDocumentsSucc"
  });
  payload.forEach((document: any) => {
      removeReceivedFile(document.processResourceUid,document.receivedFilesUid)
      removeItemMass(document.processResourceUid,document.getGatheringProcessNumber,document.getGatheringProcessIndex);
      this.dispatch("orderModule/createOrderDeletedDocument", {
        orderResourceUid: document?.orderResourceUid,
        fileResourceUid: document?.documentUpload?.resourceUid
    });
  });
  commit("setToRefresh", true)

},
    executeDeleteConfirmationRemoveSubvention({ commit }, payload) {
      commit('orderModule/setorderSubvention', payload);
      this.dispatch("hideConfirmationDeleteDialog")
    },
    executeDeleteConfirmationNotification({ dispatch }, payload) {
      dispatch("notificationModule/updateStateOfMessage",payload);
      this.dispatch("hideConfirmationDeleteDialog")
    },
     executeDeleteConfirmationParty({ commit }, param) {
      commit("setConfirmationDeleteDialogState", {
        show: false,
        deleteAction: "deleteParty"
      });
      this.dispatch("thirdModule/deleteParty", {
         resourceUid: param.resourceUid,
         type: param.type,
         request: param.request
      });
      commit("setToRefresh", true)
    },
    async showConfirmationDeleteDialog({ commit }, param) {

      const { message, target, payload, deleteAction, callback, requireTextConfirmation, confirmationText } = param;
      commit("setConfirmationDeleteDialogState", {
        message,
        target,
        show: true,
        payload,
        deleteAction,
        callback,
        requireTextConfirmation: !!requireTextConfirmation,
        confirmationText: confirmationText || "supprimer"
      });
    },
    executeConfirmationDialog({ commit }, param) {
      const { payload , target } = param;
      commit("setConfirmationDialogState", {
        show: false,
        confirmation: true
      });
      if (payload.messageTosend){
      this.dispatch("taskModule/sendMessage", { messageTosend: payload.messageTosend, module:payload.module, target:target });
     }
    }

  },
  modules: {
    filterModule,
    authModule,
    demandModule,
    picklistModule,
    thirdModule,
    simulationModule,
    searchThirdModule,
    taskModule,
    financingModule,
    middleOfficeModule,
    summaryPanelModule,
    notificationModule,
    messagingModule,
    analysisModule,
    scaleModule,
    assetModule,
    garantyModule,
    queryBuilderModule,
    availabilityModule,
    controlsModule,
    userModule,
     //Efficom Specification
    tabledata,
    dossierModule,
    commandModule,
    orderModule,
    orderCommissionModule,
    printDocumentModule,
    screnConfigurationModule,
    orderPartyModule,
    roleMenuModule,
    objectiveModule,
    AbsenceManagementModule,
    ActionModule,
    documentsModule,
    AuthorityModule,
    teamModule,
    DaaqModule,
    NetworkModule,
    contextModule,
    remunerationModule,
    DelegationModule,
    aideModule,
    signatureTemplateModule,
    emailConfigModule
  },
});
